module.exports = __webpack_public_path__ + "static/measure-cover-ff0150e8ee24295fcc4f367f2b84f3d0.svg";